"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canSubmitReads = void 0;
var reads_config_1 = require("./reads-config");
var hasValidIndustryReads = function (states) {
    return !(0, reads_config_1.readsConfig)('industryReadsRequired') ||
        (states.hasIndustryOpeningRead && states.hasIndustryActualReadIn12Months);
};
var allowSubmissionForNonComms = function (states) {
    return !states.isSmart || (states.isNonComms && (0, reads_config_1.readsConfig)('showNonCommPrompt'));
};
var canSubmitReads = function (states) {
    return states.isActive &&
        !states.isBeforeSupplyStart &&
        allowSubmissionForNonComms(states) &&
        hasValidIndustryReads(states);
};
exports.canSubmitReads = canSubmitReads;
